import { render, staticRenderFns } from "./related_institutions_data_tab.vue?vue&type=template&id=6ee582eb"
import script from "./related_institutions_data_tab.vue?vue&type=script&lang=js"
export * from "./related_institutions_data_tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports